import { render, staticRenderFns } from "./SavedGroup.vue?vue&type=template&id=3673dc70"
import script from "./savedGroup.ts?vue&type=script&lang=ts&external"
export * from "./savedGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3673dc70')) {
      api.createRecord('3673dc70', component.options)
    } else {
      api.reload('3673dc70', component.options)
    }
    module.hot.accept("./SavedGroup.vue?vue&type=template&id=3673dc70", function () {
      api.rerender('3673dc70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/checkout/buttons-group/groups/client/saved-group/SavedGroup.vue"
export default component.exports